import React from 'react';
import Select from 'react-select';
import { getSelectStyles } from '../../components/Select/selectStyles';

const ExamHeaderSelect = (props) => {
  const options = props.examList.map((exam) => ({
    value: exam.id,
    label: (
      <div>
        {exam.name} <span style={{ fontWeight: '700', color: 'var(--color-text)' }}>
          {(exam.term === '1' || exam.term === '2') ? `(TERM-${exam.term})` : `(${exam.term})`}
        </span>
      </div>
    ),
  }));

  const handleChange = (selectedOption) => {
    props.onChangeHandler({
      target: { name: "name", value: selectedOption?.value || "" },
    });
  };
  // Same label and wrapper markup as components/Select (native and searchable)
  return (
    <div className="form-group">
      {props.label && (
        <label htmlFor="name" className="mb-1 mt-1 text-capitalize fw-semibold">
          {props.label}
          {props.required && <i className="text-danger ms-1">*</i>}
        </label>
      )}
      <Select
        inputId="name"
        name="name"
        options={options}
        placeholder={props.placeholder}
        styles={getSelectStyles({ invalid: Boolean(props.error) })}
        onChange={handleChange}
        value={options.find(option => option.value === props.value) || null}
      />
      {props.error && <div className="invalid-feedback d-block mt-1">{props.error}</div>}
    </div>
  );
};

export default ExamHeaderSelect;
